export default {
      id: "predicta-right-arrow-usage",
      viewBox: "0 0 10 16",
      url: "/" + "images/icons.3.109.2.svg#predicta-right-arrow-usage",
      toString: function () {
        return this.url;
      }
    }